import React, { useEffect, useState } from "react";
import productsApiClient from "./ProductsApiClient";
import events from "../../events";
import ProductGridItem from "./ProductGridItem";
import styles from "./MyPageFavorites.module.scss";
export function MyPageFavorites({ strings, storeUrl }) {
    // type items
    const [items, setItems] = useState([]);
    useEffect(() => {
        getFavorites();
        const sub = events.onUpdateMyFavorite.subscribe(() => {
            getFavorites();
        });
        return () => sub.unSubscribe();
    }, []);
    const getFavorites = () => {
        productsApiClient.getFavoriteProducts().then(data => {
            setItems(data);
        });
    };
    return (React.createElement("div", { className: styles.productGrid }, items ? items.map(item => React.createElement(ProductGridItem, { key: item.sku, item: item, strings: strings, storeUrl: storeUrl }))
        : React.createElement("div", null, strings.emptyFavoritesList)));
}
